module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-chevy.276bb82d.png";